(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay/assets/javascripts/api-calls/wagers.js') >= 0) return;  svs.modules.push('/components/tur/pay/assets/javascripts/api-calls/wagers.js');

'use strict';

const drawgamesApiCaller = svs.tur.apiCaller.drawgames;

function payMultipleWagers(_ref) {
  let {
    next,
    cancel,
    wagers
  } = _ref;
  const success = _ref2 => {
    let {
      regWagerResults
    } = _ref2;
    return next({
      regWagerResults
    });
  };
  const error = _ref3 => {
    let {
      error
    } = _ref3;
    svs.tur.apierrors.showErrorMessage({
      response: error,
      onConfirm: cancel({
        error
      })
    });
  };
  drawgamesApiCaller.postWagerMultiwagers({
    data: {
      wagers
    },
    successCB: success,
    errorCB: error
  });
}

function payWagers(_ref4) {
  let {
    next,
    cancel,
    wagers
  } = _ref4;
  if (wagers.length > 1) {
    return payMultipleWagers({
      next,
      cancel,
      wagers
    });
  }
  drawgamesApiCaller.postWagerWagers({
    data: wagers[0],
    successCB: regWagerResult => next({
      regWagerResults: [{
        status: 'SUCCESS',
        regWagerResult
      }]
    }),
    errorCB: xhr => {
      const response = JSON.parse(xhr.responseText);
      next({
        regWagerResults: [{
          status: 'FAILURE',
          tpError: {
            errCode: response.error.code
          }
        }]
      });
    }
  });
}
Object.assign(svs.tur.pay.api_calls, {
  payMultipleWagers,
  payWagers
});

 })(window);